export default __webpack_public_path__ + "img/uploadV2white.cb7cad12.svg";